import React from 'react';
import Box from '@mui/material/Box';
import ListItems from 'components/Common/ListItems';

const DashboardLocations = (props) => {
  const { myProfile } = props;
  const locations = myProfile?.user?.assignedLocations;

  if (!locations || locations.length === 0) {
    return null;
  }

  return (
    <>
      {locations.map((item, index) => {
        const { val } = item;
        return (
          <Box key={index}>
            <ListItems title={val} />
          </Box>
        );
      })}
    </>
  );
};

export default DashboardLocations;
